import axiosInstance from "../../../configurations/Axios";
import {API_ENDPOINTS} from "../../../constant/APIEndPoints";


export const submitCredentialsRequest=async(submitCredentialsRequestModel)=>{
    try{

        const apiResponse=await axiosInstance.post(API_ENDPOINTS.SUBMIT_CREDENTIALS,submitCredentialsRequestModel);
        return apiResponse.data;
    }catch (error){
        console.log(error);
        throw new Error(error);
    }
}

export const submitNickNameRequest=async (submitNickNameRequestModel)=>{
    try{
        const apiResponse=await axiosInstance.post(API_ENDPOINTS.SUBMIT_NICK_NAME,submitNickNameRequestModel);
        return apiResponse.data;
    }catch (error){
        console.log(error);
        throw new Error(error);
    }
}